import { useFactors } from "../state/FactorsContext";
import { describeResult } from "../lib/describe";
import HeroNumber from "./HeroNumber";
import CollapseMeter from "./CollapseMeter";
import GlobalControls from "./GlobalControls";

/**
 * The persistent desktop panel. It sticks to the side and stays in view for the
 * whole journey, so the live number, the analogy, the collapse meter and the
 * global controls are always one glance away — no matter how far the reader has
 * scrolled. Hidden on mobile, where the pinned Ticker does this job instead.
 */
export default function SidePanel() {
  const { data, result } = useFactors();
  const { plain, analogy } = describeResult(result.total);

  return (
    <aside className="hidden lg:block">
      <div className="sticky top-6 mt-6 rounded-3xl border border-white/10 bg-abyss/60 p-7 backdrop-blur-md">
        <p className="text-[11px] uppercase tracking-[0.25em] text-cyan/80">
          {data.meta.title}
        </p>
        <p className="mt-1 text-xs leading-snug text-white/55">
          {data.meta.resultLabel}
        </p>

        <div className="my-6">
          <HeroNumber value={result.total} size="md" />
        </div>

        <p className="text-center font-mono text-xs text-cyan">{plain}</p>
        <p className="mt-3 text-center font-display text-base font-light italic leading-relaxed text-white/85">
          “{analogy}”
        </p>

        <div className="my-7">
          <CollapseMeter />
        </div>

        <div className="border-t border-white/10 pt-6">
          <GlobalControls />
        </div>
      </div>
    </aside>
  );
}
